import React, { useEffect, useState, useCallback } from "react";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CreateIcon from "@mui/icons-material/Create";
import Modal from "@mui/material/Modal";
// import { set } from "lodash";
import { getSecPermission, isEmptyDash, strToDate ,trimString } from "../../constant";
import { vendorServices } from "../../services/vendorServices";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress, Switch } from "@mui/material";
import { validationServices } from "../../services/validationServices";
import { Link, useLocation } from "react-router-dom";
import ConfirmModal from "../common/confirmModal";
import { adminServices } from "../../services/adminServices";
import AddSharpIcon from "@mui/icons-material/AddSharp";
import _ from "lodash";
import { subRouteMapping } from "../../constant/subRoutes";
import routes from "../../routes";
import CreateNewVendorModal from "../common/createNewVendorModal";
import RefreshIcon from '@mui/icons-material/Refresh';
import Tooltip from '@mui/material/Tooltip';
import { UserObj } from "../../services/localStarage";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import topArrow from '../../assests/images/top.png';
import topHighlightArrow from '../../assests/images/top-highlighted.png';
import bottomArrow from '../../assests/images/bottom.png';
import bottomHighlightArrow from '../../assests/images/bottom-highlighted.png';
import Filter from "../filter/filter";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined"; 
import { downloadFile } from "../buyerPurchaseOrder";
import checkImage from "../../assests/images/check-circle.png";

const initialColumns = [
  { id: "vendorId", label: "Vendor ID", isSort: true, sortLabel: "", isFiltered: false },
  { id: "vendorName", label: "Vendor Name", isSort: true, sortLabel: "", isFiltered: false },
  { id: "userName", label: "User Name", isSort: true, sortLabel: "", isFiltered: false },
  { id: "pan", label: "PAN Number", isSort: true, sortLabel: "", isFiltered: false },
  { id: "registrationDate", label: "Registration Date", isSort: true, sortLabel: "", isFiltered: false },
  { id: "category", label: "Category", isSort: true, sortLabel: "", isFiltered: false },
  { id: "contactPerson", label: "Contact Person", isSort: true, sortLabel: "", isFiltered: false },
  { id: "contactNumber", label: "Contact Number", isSort: true, sortLabel: "", isFiltered: false },
  { id: "emailAddress", label: "Email Address", isSort: true, sortLabel: "", isFiltered: false },
  { id: "state", label: "State", isSort: true, sortLabel: "", isFiltered: false },
  { id: "assignee", label: "Assignee Name", isSort: true, sortLabel: "", isFiltered: false },
  { id: "profileEvaluation", label: "Profile Evaluation", isSort: true, sortLabel: "", isFiltered: false },
  { id: "factoryVisit", label: "Factory Visit", isSort: true, sortLabel: "", isFiltered: false },
  { id: "complianceCheck", label: "Compliance Check", isSort: true, sortLabel: "", isFiltered: false },
  { id: "financialEvaluation", label: "Taxation Evaluation", isSort: true, sortLabel: "", isFiltered: false },
  { id: "accountsEvaluation", label: "Accounts Evaluation", isSort: true, sortLabel: "", isFiltered: false },
  { id: "finalRating", label: "Final Rating", isSort: true, sortLabel: "", isFiltered: false },
  { id: "finalStatus", label: "Final Status", isSort: true, sortLabel: "", isFiltered: false },
  { id: "onboardingType", label: "Onboarding type", isSort: true, sortLabel: "", isFiltered: false },
  { id: "deactivationReason", label: "Reason", isSort: true, sortLabel: "", isFiltered: false },
  { id: "action", label: "Action", isSort: true, sortLabel: "", isFiltered: false }
];


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
let inviteQuesArr1 = [
  {
    title: "Contact Name",
    name: "contactName",
    type: "text",
    placeholder: "Contact Name",
    isRequired: true,
    showAlert: false,
    disabled: false,
    alertMsg: "Please enter the valid contact name.",
    value: "",
    validationType: "text",
  },
  {
    title: "Contact Number",
    name: "contactNumber",
    type: "text",
    placeholder: "Contact Number",
    isRequired: true,
    showAlert: false,
    disabled: false,
    alertMsg: "Please enter a valid 10-digit mobile number.",
    value: "",
    validationType: "number",
  },

  {
    title: "Vendor Name",
    name: "vendorName",
    type: "text",
    placeholder: "Vendor Name",
    isRequired: true,
    showAlert: false,
    disabled: false,
    alertMsg: "Please enter the valid vendor name.",
    value: "",
    validationType: "text",
  },
  {
    title: "Vendor Email",
    name: "vendorEmail",
    type: "text",
    placeholder: "Vendor Email",
    isRequired: true,
    showAlert: false,
    disabled: false,
    alertMsg: "Please enter the vendor email.",
    value: "",
    validationType: "email",
  },
  {
    title: "Onboarding Type",
    name: "onboardingType",
    type: "select",
    placeholder: "Onboarding Type",
    isRequired: true,
    showAlert: false,
    disabled: false,
    alertMsg: "Please select onboarding type.",
    value: "REGULAR_ONBOARDING",
    validationType: "",
    options: [
      { label: "Regular Onboarding", value: "REGULAR_ONBOARDING" },
      { label: "Direct Onboarding", value: "DIRECT_ONBOARDING" },
      {
        label: "Onboarding without Document",
        value: "ONBOARDING_WITHOUT_DOCUMENTS",
      },
    ],
  },
];

let SubRouteArr = [
  {
    path: "/vendor-list-existing",
    name: " Existing Vendor ",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    // imgSrc1: dashb,
    // imgSrc2: dashw,
    // component: ExistingVendorList,
    layout: "/admin",
    isSidebar: true,
    redirect: false,
    isSubRoute: true,
    configName: "Existing Vendor List",
  },
  {
    path: "/vendor-list",
    name: "New Vendor",
    icon: "fas fa-tachometer-alt",
    miniName: "V",
    // imgSrc1: dashb,
    // imgSrc2: dashw,
    // component: VendorList,
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "Vendor List",
  },
];

const requestPayloadInitials = {
  pageNumber: 1,
  pageSize: 10,
  sortArray: [],
  searchCriteria: [],
};

const vendorListObj = {
  totalItems: 0,
  totalPages: 0,
  currentPage: 0,
  pageSize: 0,
  vendors: [],
};

const permissionInit = {
  create: false,
  read: false,
  update: false,
  delete: false,
};

function VendorList() {
  const location = useLocation();
  const [sucessMoaldOpen, setSuccessModalOpen] = useState(false);
  const [createVendorOpen, setCreateVendorOpen] = useState(false);
  const [requestPayload, setRequestPayload] = useState(requestPayloadInitials);
  const [vendorList, setVendorList] = useState(vendorListObj);
  const [filterText, setFilterText] = useState("");
  const [openfactorytodotModal, setOpenFactoryTodoModal] = useState(false);
  const [inviteQuesArr, setInviteQuesArr] = useState(inviteQuesArr1);
  const [isLoading, setIsLoading] = useState(false);
  const [changeStatusData, setChangeStatusData] = useState({});
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [reasonSelectVal, setReasonSelectVal] = useState("");
  const [reasonTextVal, setReasonTextVal] = useState("");
  const [isForMeChecked, setIsForMeChecked] = useState(true);
  const [subRouteArr, setSubRouteArr] = useState([]);
  const [inputPage, setInputPage] = useState(vendorList?.currentPage || 1);
  const [columns, setColumns] = useState(initialColumns);
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  // const [openFactoryTodoModal, setOpenFactoryTodoModal] = useState(false);
  const [files, setFiles] = useState([]);
  const [selectedFiled, setSelectedFile] = useState([]);
  const userRole = UserObj ? UserObj?.role?.name : "";

  const [secVendorListPermission, setSecVendorListPermission] = useState({
    "EDIT_VENDOR": permissionInit,
    "ACTIVATE_VENDOR": permissionInit,
  });
  
  const addFile = () => {
    const newFile = Array.from(selectedFiled).map((file) => file.name);
    setFiles((prevFiles) => [...prevFiles, ...newFile]);
    setSelectedFile([]);
  };
  const deleteFile = (index) => {
    const updatedFiles = files.filter((file, i) => i !== index);
    setFiles(updatedFiles);
  };

  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };

  useEffect(() => {
    getVendorList(requestPayload, filterText, isForMeChecked,filterFormData);
  }, [requestPayload]);

  useEffect(() => {
    setSubRouteArr(subRouteMapping(routes, "VENDOR_LIST"));
  }, []);

  // useEffect(() => { 
  //     for (let i = 0; i < SubRouteArr.length; i++) {
  //         if (location.pathname.indexOf() ==  `${routesArr[i].layout}${routesArr[i].path}`) {
  //             setIsSidebar(routesArr[i].isSidebar);
  //         }
  //     }
  // }, [location.pathname]);

  
  useEffect(() => {
    let secVendorListPermissionInit = _.cloneDeep(secVendorListPermission);
    let obj = {};
    for (let key in secVendorListPermissionInit) {
      obj[key] = getSecPermission(key);
    }
    setSecVendorListPermission(obj);
  }, []);

  const handleMandattoryToggle = (e, row, rowIndex) => {
    setChangeStatusData({ row, rowIndex });
    setIsConfirmModalOpen(true);
  };

  const handleForMeToggle = (checked) => {
    setIsForMeChecked(checked);
    getVendorList(requestPayload, filterText, checked);
  };

  const closeConfirmModal = () => {
    setChangeStatusData({});
    setIsConfirmModalOpen(false);
    setReasonSelectVal("");
    setReasonTextVal("");
  };

  const onReasonSelect = (e) => {
    let {name, value} = e.target;
    setReasonSelectVal(value);
    setReasonTextVal("");
  };

  const onReasonText = (e) => {
    let {name, value} = e.target;
    setReasonTextVal(value);
  };

  const successConfirmModal = () => {    
    let obj = {
      "isActive": !changeStatusData?.row?.status, //true,
      "id": changeStatusData?.row?._id, // "65df7b687d9c1beaea023a08",
      "isEmployee": false,
    };

    if (!changeStatusData?.row?.status == false && isEmptyDash(reasonSelectVal)) {
      openAlert(true, "error", `Please select any reason.`);
      return;
    }

    if (!changeStatusData?.row?.status == false && reasonSelectVal == "Other" && isEmptyDash(reasonTextVal) ) {
      openAlert(true, "error", `Please enter any reason.`);
      return;
    }

    if (!changeStatusData?.row?.status == false) {
      obj["deactivationReason"] = reasonSelectVal;
      if (reasonSelectVal == "Other") {
        obj["deactivationReason"] = reasonTextVal;        
      }
    }
    // console.log(obj, !changeStatusData?.row?.status);

    setIsLoading(true);
    adminServices
      .changeUserSatus(obj)
      .then((res) => {
        if (res.data.success === true) {
          getVendorList(requestPayload, filterText, isForMeChecked);
          setChangeStatusData({});
          closeConfirmModal();
          openAlert(true, "success", `${res.data?.message}`);
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const validateForm = () => {
    let inviteQuesArrClone = [...inviteQuesArr];
    let isValidate = true;
    let bodyData = {};
    bodyData['isAllowedToBid'] = false;
    for (let i = 0; i < inviteQuesArrClone.length; i++) {
      bodyData[inviteQuesArrClone[i].name] = inviteQuesArrClone[i].value;
      inviteQuesArrClone[i].showAlert = false;
      if (isEmptyDash(inviteQuesArrClone[i].value)) {
        isValidate = false;
        inviteQuesArrClone[i].showAlert = true;
        setInviteQuesArr(inviteQuesArrClone);
        break;
      }
      if (inviteQuesArrClone[i].validationType == "number") {
        let validationRes = validationServices.validatePhoneNumber(
          inviteQuesArrClone[i].value
        );
        if (!validationRes) {
          isValidate = false;
          inviteQuesArrClone[i].showAlert = true;
          setInviteQuesArr(inviteQuesArrClone);
          break;
        }
      }
      if (inviteQuesArrClone[i].validationType === "text") {
        let validationRes = validationServices.validateText(
          inviteQuesArrClone[i].value
        );
        if (!validationRes) {
          isValidate = false;
          inviteQuesArrClone[i].showAlert = true;
          setInviteQuesArr(inviteQuesArrClone);
          break;
        }
      }
    }

    if (isValidate) {
      setIsLoading(true);
      vendorServices
        .createVendorInvite(bodyData)
        .then((res) => {
          setSuccessModalOpen(true);
          setCreateVendorOpen(true);
          setInviteQuesArr(inviteQuesArr1);
        })
        .catch(function (error) {
          setAlertComponent({
            open: true,
            type: "error",
            message: `${error?.response?.data?.message}`,
          });
        })
        .finally((param) => {
          setIsLoading(false);
        });
    }
  };

  const onVendorCreationSucces = () => {
    setSuccessModalOpen(false);
    window.location.reload();
  };

  const onVendorCreationSuccesClose = () => {
    setSuccessModalOpen(false);
    window.location.reload();
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };

  const inviteModalClose = () => {
    let inviteQuesArrClone = [...inviteQuesArr];
    for (let i = 0; i < inviteQuesArrClone.length; i++) {
      if (inviteQuesArrClone[i].type == "text") {
        inviteQuesArrClone[i].value = "";
      }
    }

    setInviteQuesArr(inviteQuesArrClone);
    setCreateVendorOpen(false);
  };

  const onTextChange = (e, data, index) => {
    let { value } = e.target;
    if (data?.name === 'vendorName') {
      const cursorPosition = e.target.selectionStart;
      const startValue = inviteQuesArr[index].value;
      let value = e.target.value.toUpperCase();
      if (startValue !== value) {
        let inviteQuesArr3 = [...inviteQuesArr];
        inviteQuesArr3[index].value = value;
        setInviteQuesArr(inviteQuesArr3);
        requestAnimationFrame(() => {
          e.target.setSelectionRange(cursorPosition, cursorPosition);
        });
      }
    } else {
      let inviteQuesArr3 = [...inviteQuesArr];
      inviteQuesArr3[index].value = value;
      setInviteQuesArr(inviteQuesArr3);
    }
  };

  const onSelectChange = (e, data, index) => {
    let { name, value } = e.target;
    let inviteQuesArr3 = [...inviteQuesArr];
    inviteQuesArr3[index].value = value;
    setInviteQuesArr(inviteQuesArr3);
  };

  const getVendorList = (requestPayloadParam, filterTextParam, checked,formData) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}`;
    if (checked != true) {
      param += `&selfAssignee=${!checked}`;
    }
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }

    const filteredFormData = formData ? Object.entries(formData)
      .filter(([key, value]) => value !== '')
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {}) : {};
    if (filteredFormData && Object.keys(filteredFormData).length > 0) {
      Object.entries(filteredFormData).forEach(([key, value]) => {
        param += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      });
    }

    vendorServices
      .getVendorList(param)
      .then((res) => {
        if (res.data.success == true) {
          setVendorList(res.data.data);
        } else {
          setAlertComponent({
            open: true,
            type: "error",
            message: `No Data Found `,
          });
        }
      })
      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message}`,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });

    // requestPayload.searchCriteria = [...this.state.initialSearchCriteriaArr];
    // let param = `employeeUserId=${userObj?.userId}&pageNumber=${requestPayload?.pageNumber}&pageSize=${requestPayload?.pageSize}`;
    // for (let i = 0; i < requestPayload.searchCriteria.length; i++) {
    //   param += `&${requestPayload.searchCriteria[i].key}=${requestPayload.searchCriteria[i].value}`;
    // } 

    // if (param?.salesOrderIdSearch == "" && param?.externalReferenceIdSearch == "" && param?.orderCategorySearch == "" && param?.orderSourceSearch == "" && param?.buyerFirmNameSearch == "" && param?.poIdSearch == "" && param?.totalValueSearch == "" && param?.orderDateTimeSearch == "" && param?.invoiceStatusSearch == "" ) {
    //   param.filter = 'no';
    // } else {
    //   param.filter = 'yes';
    // }
  };
  const onFilterTextChange = (e) => {
    setFilterText(e.target.value);
    debouncedSearch(e.target.value);
  };

  const debouncedSearch = useCallback(
    _.debounce((searchTerm) => {
      let requestPayloadInit = _.cloneDeep(requestPayload);
      requestPayloadInit.pageNumber = 1;
      setRequestPayload(requestPayloadInit);
    }, 800),
    []
  );

  const onKeyPressHandler = (e) => {
    e.persist();
    if (e.key === "Enter") {
      onFilterSubmit();
    }
  };

  const onFilterSubmit = () => {
    getVendorList(requestPayload, filterText, isForMeChecked,filterFormData);
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, filters, data }
  ) => {
    if (type === "pagination") {
      setRequestPayload({
        ...requestPayload,
        pageNumber: page,
        pageSize: sizePerPage,
      });
    }
    if (type == "sort") {
      setRequestPayload({
        ...requestPayload,
        sortArray: [sortField, sortOrder],
      });
      // const requestPayload = {
      //   ...this.state.requestPayload,
      //   sortArray: [sortField + "," + sortOrder],
      // };
      // this.getRoleWiseSOList(requestPayload);
      // this.props.getSalesOrderList(requestPayload);
      // this.setState({
      //   sorting: true,
      // })
    }
    if (type == "filter") {
      // const requestPayload = { ...this.state.requestPayload };
      // let secondSearchCriteriaArr = [];
      // // let secondSearchCriteriaArr = Object.keys(filters).map((ele) => {
      // //   let obj = {
      // //     key: ele,
      // //     value: filters[ele].filterVal,
      // //     operation: filters[ele].comparator,
      // //   };
      // //   return obj;
      // // });
    }
  };

  // const columns = [
  //   {
  //     dataField: "Checkbox",
  //     text: "Select",
  //     formatter: (cell, row) => {
  //       return <input type="checkbox" id={row._id} />;
  //     },
  //   },
  //   {
  //     dataField: "vendorId",
  //     text: `Vendor ID`,
  //     sort: true,
  //   },
  //   {
  //     dataField: "vendorName",
  //     text: "Vendor Name",
  //     events: {
  //       onChange: (e, column, columnIndex, row, rowIndex) => { },
  //     },
  //     formatter: (cell, row, rowIndex) => {
  //       return (
  //         <Link to={`/admin/vendor-list-details/${row._id}`}>
  //           {row.vendorName}
  //         </Link>
  //       );
  //     },
  //     sort: true,
  //   },
  //   {
  //     dataField: "userName",
  //     text: `UserName`,
  //     sort: true,
  //   },
  //   {
  //     dataField: "pan",
  //     text: `PAN Number`,
  //     sort: true,
  //   },
  //   {
  //     dataField: "registrationDate",
  //     text: "Registration Date",
  //     events: {
  //       onChange: (e, column, columnIndex, row, rowIndex) => { },
  //     },
  //     formatter: (cell, row, rowIndex) => {
  //       return isEmptyDash(row.registrationDate)
  //         ? "-"
  //         : strToDate(row.registrationDate);
  //     },
  //     sort: true,
  //   },
  //   {
  //     dataField: "category",
  //     text: "Category",
  //   },

  //   {
  //     dataField: "contactPerson",
  //     text: "Contact Person",
  //     sort: true,
  //   },
  //   {
  //     dataField: "contactNumber",
  //     text: " Contact Number",
  //     sort: true,
  //   },

  //   {
  //     dataField: "emailAddress",
  //     text: "Email Address",
  //     sort: true,
  //   },
  //   {
  //     dataField: "state",
  //     text: "State",
  //   },
  //   {
  //     dataField: "assignee",
  //     text: "Assignee Name",
  //   },
  //   {
  //     dataField: "profileEvaluation",
  //     text: "Profile Evaluation",
  //   },

  //   {
  //     dataField: "factoryVisit",
  //     text: "Factory Visit",
  //   },

  //   {
  //     dataField: "complianceCheck",
  //     text: "Compliance Check",
  //   },
  //   {
  //     dataField: "financialEvaluation",
  //     text: "Financial Evaluation",
  //   },
  //   {
  //     dataField: "finalRating",
  //     text: "Final Rating",
  //   },
  //   {
  //     dataField: "finalStatus",
  //     text: "Final Status",
  //   },
  //   {
  //     dataField: "onboardingType",
  //     text: "Onboarding type",
  //   },
  //   {
  //     dataField: "action",
  //     text: "Action",
  //     events: {
  //       onChange: (e, column, columnIndex, row, rowIndex) => { },
  //     },
  //     formatter: (cell, row, rowIndex) => {
  //       return (
  //         <div className="d-flex">
  //           <div className=""> {row?.status ? "Active" : "Deactive"} </div>
  //           <Switch
  //             className="emp-ls-active-txt"
  //             checked={row?.status}
  //             onChange={(e) => handleMandattoryToggle(e, cell, row, rowIndex)}
  //           />
  //           <div
  //             className="vendor-action"
  //             onClick={(e) => openAlert(true, "success", `Coming Soon.`)}
  //           >
  //             <CreateIcon className="edit_icon_panel" />
  //           </div>
  //           {row?.newUser === true && userRole === 'BUYER' && (
  //             <button type="button" class="btn" fdprocessedid="cn5f6" onClick={(e) => handleReInitiateVendor(row?._id)}>
  //               <Tooltip title="Re-invite" placement="top-start" arrow>
  //                 <RefreshIcon />
  //               </Tooltip>
  //             </button>
  //           )}

  //         </div>
  //       );
  //     },
  //     // sort: true,
  //   },
  //   // {
  //   //   dataField: "action",
  //   //   text: "Action",
  //   //   events: {
  //   //     onChange: (e, column, columnIndex, row, rowIndex) => {},
  //   //   },
  //   //   formatter: (cell, row, rowIndex) => {
  //   //     return (
  //   //       <div className="d-flex">
  //   //         <div className="vendor-action"> View </div>
  //   //         <div className="vendor-action"> | Edit </div>
  //   //         <div className="vendor-action"> | Update Status </div>
  //   //       </div>
  //   //     );
  //   //   },
  //   // },
  // ];
  const handleReInitiateVendor = (vendorId) => {
    setIsLoading(true);
    let bodydata = {};
    bodydata = {
      "vendorId": vendorId,
    }
    vendorServices.reIinviteVendor(bodydata)
      .then((res) => {
        if (res.data.success === true) {
          setAlertComponent({ open: true, type: "success", message: `${res.data.message}` });
        } else {
          setAlertComponent({ open: true, type: "error", message: `Something Went Wrong` });
        }
      })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const onPaginationChange = (e, value) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageNumber = value;
    setRequestPayload(requestPayloadInit);
  }

  const onPageSizeChange = (e) => {
    let { value } = e.target;
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageSize = value;
    requestPayloadInit.pageNumber = 1;
    setRequestPayload(requestPayloadInit);
  }
  const handleInputChange = (event) => {
    const value = event.target.value;
    if (value === '' || /^[0-9]+$/.test(value)) {
      setInputPage(value);
    }
  };
  const handleInputSubmit = (event) => {
    if (event.key === 'Enter') {
      const pageNumber = parseInt(inputPage, 10);
      if (pageNumber >= 1 && pageNumber <= vendorList?.totalPages) {
        onPaginationChange(null, pageNumber);
      }
    }
  };
  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const reorderedColumns = Array.from(columns);
    const [removed] = reorderedColumns.splice(result.source.index, 1);
    reorderedColumns.splice(result.destination.index, 0, removed);

    setColumns(reorderedColumns);
  };
  const onSortChange = (index, sortBy, sortOrder) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    let columnsInit = _.cloneDeep(columns);
    let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
    requestPayloadInit.sortArray = [sortBy, newSortLael];
    requestPayloadInit.pageNumber = 1;
    columnsInit[index].sortLabel = newSortLael;
    setRequestPayload(requestPayloadInit);
    setColumns(columnsInit);
  }

  const [filterFormData, setFilterFormData] = useState("");   
  const [activeFilters, setActiveFilters] = useState([]); 
  const [isFilterTabOpen, setIsFilterTabOpen] = useState(false);
  const handleFilterFormSubmit = (formDataa) => {
    setFilterFormData(formDataa);
    const updatedPayload = {
      ...requestPayload,
      searchCriteria: formDataa,
    };
    setRequestPayload(updatedPayload); 
    getVendorList(requestPayload, filterText, isForMeChecked,formDataa);
    const updatedColumns = columns.map((col) => {
      const isFiltered = Object.keys(formDataa).includes(col.id);
      return { ...col, isFiltered };
    });
    setColumns(updatedColumns);

    const filters = Object.keys(formDataa).map((key) => {
      if (key.endsWith('_from_date') || key.endsWith('_to_date')) {
        const fieldBaseName = key.replace('_from_date', '').replace('_to_date', '');
        return `${fieldBaseName}: ${formDataa[key.replace('_from_date', '') + '_from_date'] || ''} to ${formDataa[key.replace('_from_date', '') + '_to_date'] || ''}`;
      }
      return `${key}:${formDataa[key]}`;
    });
    setActiveFilters(filters);
  }; 
  useEffect(() => { 
    getVendorList(requestPayload, filterText, isForMeChecked,filterFormData);
  }, [requestPayload]);

 
  const handleResetFormSubmit = () => {
    getVendorList(requestPayload, filterText,isForMeChecked, {});
    const resetColumn = columns.map(col => ({
      ...col, isFiltered: false,
    }))
    setColumns(resetColumn); 
    setFilterFormData({});
  }  
  const [openheaderlevelsucessfullymodal, setOpenHeaderLevelSucessfullyModal] =
  useState(false);
  const downloadList = () => {    
    setIsLoading(true);
    let bodyData = {
      "newVendors": true,
      ...filterFormData
    };

    if (!isEmptyDash(filterText)) {
      bodyData["search"] = filterText;
    }

    let fileName = "";    
    const data = {
      url: `/v1/common/vendor-list/download`,
      bodyData: bodyData,
      method: "POST",
      fileName: fileName
    };
    downloadFile(data)
      .then(response => { 
           if (isEmptyDash(response)) {
            // setOpenHeaderLevelExcelModal(false);
             setOpenHeaderLevelSucessfullyModal(true);          
          } else {        
            setAlertComponent({ open: true, type: "success", message: `${response?.data?.message}` });          
          }
      })
      .catch(error => {
        setAlertComponent({ open: true, type: "error", message: `There is some error to download file. ` });
      })
      .finally(() => {
        setIsLoading(false);
        // setOpenHeaderLevelExcelModal(false);
      });    
  };

  return (
    <div className="login-forms">
      <div className="text-centers">
        <div className="heading_search_outer d sub-route-upper-sec">
          <div>
            <div className="sub-route-sec">
              {subRouteArr?.map(
                (ele, i) =>
                  ele.isSubRoute && (
                    <div
                      className={
                        location.pathname.indexOf(ele.path) !== -1
                          ? "sub-route-sec-div sub-route-sec-div-active"
                          : "sub-route-sec-div"
                      }
                    >
                      <Link to={ele.layout + ele.path}>{ele.name}</Link>
                      {/* <p>Existing Vendor</p> */}
                    </div>
                  )
              )}
            </div>
          </div>
        </div>
        <div>
          <div className="lets_new_vendor_list_upper_react_blocklist_body">
            <div className="search-filter-sec">
              <div className="search_filter_outer ">
                <div className="search_main">
                  <div id="custom-search-input">
                    <div className="input-group col-md-12">
                      <input
                        type="text"
                        className="form-control input-lg"
                        placeholder="Search here"
                        // fdprocessedid="7yu8sn"
                        onChange={onFilterTextChange}
                        value={filterText}
                        onKeyPress={onKeyPressHandler}
                      />
                      <span className="input-group-btn">
                        <button
                          disabled
                          className="btn btn-info btn-lg"
                          type="button"
                        // onClick={onFilterSubmit}
                        >
                          <span className="glyphicon glyphicon-search">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-search"
                              viewBox="0 0 16 16"
                            >
                              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                            </svg>
                          </span>
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="vendor_btn">
              <div>
                <span>For Me</span>
                <Switch
                  className="emp-ls-active-txt"
                  checked={isForMeChecked}
                  onChange={(e) => handleForMeToggle(e.target.checked)}
                />
                <span>For All</span>

              </div>
            <div className="bpdt_po_order_react">
                <div className="row_filterrbtnvendor_box">
                  <div className="lets_filter_vendorlist_body_detail filter_box" id="">
                    <FilterAltOutlinedIcon />
                    <Filter uniqueName="NEW_VENDOR" formSubmitFunction={handleFilterFormSubmit} resetFilter={handleResetFormSubmit} handleViewFilter={setIsFilterTabOpen}/>
                  </div> 
                </div> 
            </div>
              <Button
                className="vendor_maine_contentses vendor_react_onboarding"
                onClick={() => setCreateVendorOpen(true)}
              >
                <i className="fa fa-plus"></i>
                <AddSharpIcon />
                Create Vendor Onboarding
              </Button>
              
              {/* {(secPOPermission["DOWNLOAD_PO"]?.read == true) &&  */}
              {(true) && 
              <button
                className="vendor_btn_bpdt_react_divs vendor_maine_contents"
                id="basic-button"
                // aria-controls={download ? "basic-menu" : undefined}
                aria-haspopup="true"
                // aria-expanded={download ? "true" : undefined}
                onClick={downloadList}
              >
                <FileDownloadIcon />
                Download
              </button>}

              <AlertComponent
                alertComponent={alertComponent}
                handleClose={handleClose}
              />
              {/*          
              <Button
            onClick={() => setOpenFactoryTodoModal(true)}
            className="btn btn-success"
          >
            Factory Visit
          </Button>
          <div className="filter_main">
                <div className="lets_filter_vendorlist_body_detail">
                  <FilterAltOutlinedIcon className="filter_icon_detail" />
                  <Filter />
                </div>
                
                <Backdrop
                  sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                  }}
                  open={isLoading}
                >
                  <CircularProgress color="inherit" />
                </Backdrop>
              </div> */}
            </div>
          </div>
          <div className="react-bootstrap-table-vendors">
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="droppable" direction="horizontal">
                {(provided) => (
                  <div style={{ width: "100%", overflow: "hidden" }}
                    className="listing_main listing_main_dragdropcontext_body listingmain"
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                  >
                    <table className="dragdropcontext_ondragend_block_row">
                      <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                        <tr>
                          <th className="vendor_tabels">
                            <input type="checkbox" />
                          </th>
                          {columns.map((column, index) => (
                            <Draggable
                              key={column.id}
                              draggableId={column.id}
                              index={index}
                            >
                              {(provided) => (
                                <th
                                  className={`vendor_tabels ${column.isFiltered ? 'highlighted_column' : ''}`}
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  {column.label}
                                  {(column.isSort == true) && <span onClick={(e) => onSortChange(index, column.id, column.sortLabel)} className="table-sort-ico">
                                    {/* <SwapVertIcon className="swap-sort-ico" /> */}
                                    {(column.sortLabel != "asc") && <img src={topArrow} />}
                                    {(column.sortLabel == "asc") && <img src={topHighlightArrow} />}
                                    {(column.sortLabel != "desc") && <img src={bottomArrow} />}
                                    {(column.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                                  </span>}
                                </th>
                              )}
                            </Draggable>
                          ))}
                        </tr>
                      </thead>
                      <tbody style={{ overflowY: "scroll", width: "200px" }}>
                        {vendorList?.vendors.length < 1 && <>
                          <tr>
                            <td colSpan={10} className="text-center list-no-data">No Data Found</td>
                          </tr>
                        </>}
                        {vendorList?.vendors.length > 0 && <>
                          {vendorList?.vendors?.map((row, rowIndex) => (
                            <tr key={rowIndex} className="maine_tr_vendor">
                              <td>
                                <input type="checkbox" id={row._id} />
                              </td>
                              {columns.map((column, index) => (
                                <td key={index}>
                                  {column.id === "vendorName" ? (
                                    <Link to={`/admin/vendor-list-details/${row._id}`}>
                                    <Tooltip title={row[column.id] || "N/A"}>
                            {trimString(row[column.id], 8 || "N/A")}
                            </Tooltip>
                                    </Link>
                                  ) : (column.id === "registrationDate") ? (
                                    <span
                                      className="solutions_block_body"
                                      style={{ textDecoration: "none" }}
                                    >
                                      {isEmptyDash(row.registrationDate)
                                        ? "-"
                                        : strToDate(row[column.id])}
                                    </span>
                                  ) : (column.id === "action") ? (
                                    <div className="d-flex">
                                      <div className=""> {row?.status ? "Active" : "Deactive"} </div>
                                      <Switch
                                        className="emp-ls-active-txt"
                                        checked={row?.status}
                                        onChange={(e) => handleMandattoryToggle(e, row, rowIndex)}
                                        disabled={secVendorListPermission?.ACTIVATE_VENDOR?.read != true}
                                      />
                                      {/* <div
                                        className="vendor-action"
                                        onClick={(e) => openAlert(true, "success", `Coming Soon.`)}
                                      >
                                        <CreateIcon className="edit_icon_panel" />
                                      </div> */}
                                      {row?.newUser === true && userRole === 'BUYER' && (
                                        <button type="button" class="btn" fdprocessedid="cn5f6" onClick={(e) => handleReInitiateVendor(row?._id)}>
                                          <Tooltip title="Re-invite" placement="top-start" arrow>
                                            <RefreshIcon />
                                          </Tooltip>
                                        </button>
                                      )}

                                    </div>
                                  ) : (
                                    <Tooltip title={row[column.id] || "N/A"}>
                            {trimString(row[column.id], 10 || "N/A")}
                            </Tooltip>
                                  )}
                                </td>
                              ))}
                            </tr>
                          ))}
                        </>}

                      </tbody>
                    </table>
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
            {/* <BootstrapTable
              remote={{ search: true, pagination: true, sort: true }}
              bootstrap4
              keyField="id"
              data={vendorList?.vendors}
              columns={columns}
              sort={true}
              // pagination={paginationFactory()}
              onTableChange={handleTableChange}
              noDataIndication={"No Data Found"}
              pagination={paginationFactory({
                page:
                  requestPayload.pageNumber == 0
                    ? 1
                    : requestPayload.pageNumber,
                sizePerPage: requestPayload.pageSize,
                totalSize: vendorList?.totalItems,
                showTotal: true,
                pageStartIndex: 1,
                paginationSize: 2,
              })}
            /> */}

            {vendorList?.vendors.length > 0 && <>
              <div className="lets_pagination_package_listing_react">
                <div className="pagination_select_react_packagelr_detail">
                  <select
                    className="form-select packagelrlisting from-hs"
                    onChange={onPageSizeChange}
                    value={requestPayload?.pageSize}
                  >
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="20">20</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                  </select>
                  <span className="react_text_showing">
                    {` Showing rows ${Number(vendorList?.pageSize) * Number(vendorList?.currentPage - 1) + 1} to ${Number(vendorList?.pageSize) * Number(vendorList?.currentPage - 1) + Number(vendorList?.vendors.length)} of ${vendorList?.totalItems} `}
                  </span>
                </div>

                <Stack spacing={2}>
                  <Pagination
                    count={vendorList?.totalPages}
                    page={vendorList?.currentPage}
                    onChange={(event, page) => {
                      setInputPage(page);
                      onPaginationChange(event, page);
                    }}
                    renderItem={(item) => {
                      if (item.page === vendorList?.currentPage) {
                        return (
                          <input
                            className="form-control form-hasw"
                            type="text"
                            value={inputPage}
                            onChange={handleInputChange}
                            onKeyDown={handleInputSubmit}
                            style={{ width: "50px", marginLeft: "5px", marginRight: "5px", textAlign: "center" }}
                          />
                        );
                      }
                      return (
                        <PaginationItem
                          className="pagination_react_listings"
                          slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                          {...item}
                        />
                      );
                    }}
                  />
                </Stack>
              </div>
            </>}

            {/* <BootstrapTable
                    remote={{ search: true, pagination: true, sort: true }}
                    bootstrap4
                    keyField="id"
                    data={this.state.salesListData}
                    columns={columns}
                    filter={filterFactory()}
                    onTableChange={this.handleTableChange}
                    noDataIndication={this.state.noDataIndication}
                    // pagination={
                    //   this.state.salesListData.length > 0
                    //     ? paginationFactory({
                    //         page:
                    //           this.state.requestPayload.pageNumber == 0
                    //             ? 1
                    //             : this.state.requestPayload.pageNumber,
                    //         sizePerPage: this.state.requestPayload.pageSize,
                    //         totalSize: this.props.salesOrderList.totalElements,
                    //         showTotal: true,
                    //         pageStartIndex: 1,
                    //         paginationSize: 10,
                    //       })
                    //     : null
                    // }
                    pagination={paginationFactory({
                      page:
                        this.state.requestPayload.pageNumber == 0
                          ? 1
                          : this.state.requestPayload.pageNumber,
                      sizePerPage: this.state.requestPayload.pageSize,
                      totalSize: this.props.salesOrderList?.totalElements,
                      showTotal: true,
                      pageStartIndex: 1,
                      paginationSize: 2,
                    })}
                  /> */}
          </div>
        </div>
      </div>

      {/* Success Modal */}
      <Modal
        open={sucessMoaldOpen}
        onClose={() => setSuccessModalOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="react_sucess_modal_listing">
          <div className="modal-header">
            <h5 className="modal-title" id="contactModalLabel"></h5>
            <button
              type="button"
              className="btn-close"
              data-dismiss="modal"
              aria-label="Close"
              fdprocessedid="7f6r2r"
              onClick={() => onVendorCreationSuccesClose()}
            ></button>
          </div>
          <div className="text-center">
            <Typography className="vendor_invited_block_main_">
              New Vendor has been Invited <br />
              Successfully
            </Typography>
            <button
              type="button"
              className="btn btn-success "
              onClick={onVendorCreationSucces}
            >
              View All Vendors
            </button>
          </div>
        </Box>
      </Modal>
      {/*Factory Visit Todo Modal */}

      <Modal
        open={openfactorytodotModal}
        onClose={() => setOpenFactoryTodoModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="react_sucess_modal_listing">
          <div className="modal-header">
            <h5 className="modal-title" id="contactModalLabel">
              Factory Visit
            </h5>
            <button
              type="button"
              className="btn-close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => setOpenFactoryTodoModal(false)}
            ></button>
          </div>
          <div className="text-center">
            <div className="row">
              <div className="col-md-6 lets_onboarding_wizard_react">
                <div className="">
                  <div className="mb-3 upload-sec-files">
                    <input
                      className="form-control form-h choose"
                      type="file"
                      id="fileInput"
                      multiple
                      onChange={(e) => setSelectedFile(e.target.files)}
                    />
                    <Button onClick={addFile} className="btn upload_block">
                      Upload
                    </Button>
                  </div>
                </div>
              </div>
              <div className="col-md-6 lets_onboarding_wizard_react"></div>
            </div>
            <div className="modal-body download-list-modal">
              <form id="employeeForm">
                <table className="table" id="employeeTable">
                  <thead className="">
                    <tr>
                      <th className="vendor_tabels">S.No.</th>
                      <th className="vendor_tabels">Document Name</th>
                      <th className="vendor_tabels">Download</th>
                    </tr>
                  </thead>
                  <tbody>
                    {files?.map((ele, index) => (
                      <tr key={index}>
                        <td className="maine_tr_vendors">{index}</td>
                        <td className="maine_tr_vendors">{ele}</td>
                        <td className="maine_tr_vendors">
                          <RemoveRedEyeIcon className="remove_icon_react_block_body" />
                          <DeleteOutlineIcon
                            className="delete_icon_react_block_body"
                            onClick={() => deleteFile(index)}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </form>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
                open={isConfirmModalOpen}
                onClose={closeConfirmModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    sx={style}
                    className="modal_react_controlpanel_employee MuiBox-root css-1wnsr1i"
                >
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel"></h5>
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={closeConfirmModal}
                        ></button>
                    </div>
                    
                    <div className="modal-body ">
                    <h5 className="modal-title" id="exampleModalLabel">Do you want to {(changeStatusData?.row?.status == false) ? "Activate" : "Deactivate"} this vendor?</h5>
                       {(changeStatusData?.row?.status == true) && <div className="">                        
                          <div className="w-100">
                              <p className="project_code_texts_creationlisbv">Please select any reason </p>
                                                            
                              <select
                                className="form-select w-100"
                                aria-label="Default select example"
                                // name={ele.uniqueName}
                                // value={trimString(rfqDetails[ele.uniqueName] || "", 20)}
                                value={reasonSelectVal}
                                onChange={onReasonSelect}
                              >
                                <option value="">Select</option> 
                                <option value="Based on Vendor Performance Evaluation">Based on Vendor Performance Evaluation</option> 
                                <option value="Involvement in Unprofessional/ Unethical activities">Involvement in Unprofessional/ Unethical activities</option> 
                                <option value="Due to Vendor GST default">Due to Vendor GST default</option> 
                                <option value="Non-association for past 3 years">Non-association for past 3 years</option> 
                                <option value="Other">Other</option> 
                                
                              </select>
                          </div>
                          
                          {(reasonSelectVal == "Other") && <div >
                              <p className="project_code_texts_creationlisbv">Enter reason </p>
                              <textarea 
                                type="text" 
                                className="form-control input-lg " 
                                value={reasonTextVal}
                                onChange={onReasonText}
                              />
                          </div>}
                       </div>}

                        <div style={{marginTop: "14px"}}>
                            <button
                                type="button"
                                className="btn clear_btn"
                                data-bs-dismiss="modal"
                                onClick={closeConfirmModal}
                            >
                              Close
                                {/* {props.closeText ? props.closeText : 'Close'} */}

                            </button>
                            <Button
                                type="button"
                                className="btn btn-success save_next_btn  sap_confirm"
                                onClick={successConfirmModal}
                            >
                                Confirm
                            </Button>
                        </div>
                    </div>
                </Box>
            </Modal>
      
            <Modal
              open={openheaderlevelsucessfullymodal}
              onClose={() => setOpenHeaderLevelSucessfullyModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenHeaderLevelSucessfullyModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <img src={checkImage} alt="" />
                  <p class="project_Manager_bidding">
                   File has been  downloaded successfully.
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setOpenHeaderLevelSucessfullyModal(false);
                      }}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
      <CreateNewVendorModal
        createVendorOpen={createVendorOpen}
        inviteQuesArr={inviteQuesArr}
        inviteModalClose={inviteModalClose}
        validateForm={validateForm}
        modalMsg="Create Vendor Onboarding"
      />

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => 999999,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* <ConfirmModal
        isConfirmModalOpen={isConfirmModalOpen}
        closeConfirmModal={closeConfirmModal}
        successConfirmModal={successConfirmModal}
        modalMsg="Do you want to continue?"
      /> */}
    </div>
  );
}

export default VendorList;
